module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Regular-a25806274237d06e00a6888155519b98.woff2";